import type { PagedResultDto } from "../dto/pagedResultDto"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { ActivityDetailModel } from "@models/activity/activityModel"

class ActivityService {
  public async createOrUpdate(body: any) {
    const result = await http.post(
      `api/services/app/Activity/CreateOrUpdate`,
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return result.data.result
  }

  public async delete(id: number) {
    const result = await http.delete("api/Activity/Delete", {
      params: { id },
    })
    return result.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("Error"), L("EntityNotFound"))
    }

    const result = await http.get("api/services/app/Activity/Get", {
      params: { id },
    })

    return ActivityDetailModel.assign(result.data.result)
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Activity/GetAll", {
      params,
    })
    const { result } = res.data
    return result
  }
}

export default new ActivityService()
